import {
  ContentType,
  getBaseContentTypeFromMimeType,
  getMostSuitableAudioOnlyMimeType,
} from '../../constants/mediaFormatProfiles';

export interface AudioOnlyRecordingFormat {
  mimeType: string;
  contentType: ContentType;
}

export function resolveAudioOnlyRecordingFormat(
  probeStream?: MediaStream,
): AudioOnlyRecordingFormat {
  const mimeType = getMostSuitableAudioOnlyMimeType(probeStream);

  return {
    mimeType,
    contentType: getBaseContentTypeFromMimeType(mimeType) ?? 'audio/webm',
  };
}
